var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path4, _rect13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTechTableApplications3 = function SvgTechTableApplications3(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480.1 182.3",
    enableBackground: "new 0 0 480.1 182.3",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tech_table_applications_3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#29526B",
    d: "M412.2,71.1c6.3-6.2,8.1-15.7,4.6-23.8l-15.6,15.6l-7.5-3.3l-3.9-8l15.6-15.6c-11-4.7-23.7,0.4-28.4,11.3 c-2.3,5.5-2.3,11.6,0,17.1l-23.5,23.5l11.3,11.3l23.6-23.6C396.5,79.1,405.9,77.3,412.2,71.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#29526B",
    d: "M306.1,116.1c-6.3,6.2-8.1,15.7-4.6,23.8l15.6-15.6l7.5,3.3l3.9,8l-15.6,15.6c11,4.7,23.7-0.3,28.4-11.3 c2.4-5.5,2.4-11.7,0-17.2l23.5-23.6l-11.3-11.3L330,111.5C321.8,108,312.4,109.8,306.1,116.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#29526B",
    d: "M182.9,48.8v82h82v-82L182.9,48.8z M260.9,126.8H187V52.8h73.9V126.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 220.6,
    y: 52.2,
    fill: "#29526B",
    width: 5.5,
    height: 16.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 205.4,
    y: 94.4,
    fill: "#FF931E",
    width: 3.1,
    height: 25.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 210.9,
    y: 94.4,
    fill: "#FF931E",
    width: 4.1,
    height: 25.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 94.4,
    fill: "#FF931E",
    width: 1.4,
    height: 25.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 220.3,
    y: 94.4,
    fill: "#FF931E",
    width: 3.1,
    height: 25.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 225.7,
    y: 94.4,
    fill: "#FF931E",
    width: 4.1,
    height: 25.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 231.5,
    y: 94.4,
    fill: "#FF931E",
    width: 1.4,
    height: 25.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 234.4,
    y: 94.4,
    fill: "#FF931E",
    width: 1.4,
    height: 25.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 237.5,
    y: 94.4,
    fill: "#FF931E",
    width: 1.4,
    height: 25.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 249.6,
    y: 94.4,
    fill: "#FF931E",
    width: 3.1,
    height: 25.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 243.2,
    y: 94.4,
    fill: "#FF931E",
    width: 4.1,
    height: 25.6
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 94.4,
    fill: "#FF931E",
    width: 1.4,
    height: 25.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#29526B",
    d: "M108.6,45.6c6.2,0,11.3-5.1,11.3-11.3S114.8,23,108.6,23c-6.2,0-11.3,5.1-11.3,11.3 C97.3,40.6,102.3,45.6,108.6,45.6C108.6,45.6,108.6,45.6,108.6,45.6z M120.4,48.1H96.5c-8,0-14.5,6.6-14.4,14.6c0,0,0,0.1,0,0.1 v34.7c0,6.7,9.9,6.7,9.9,0V65.7h2.3v86.8c0,9,13.1,8.7,13.1,0v-50.4h2.3v50.4c0,8.7,13.2,9,13.2,0V65.7h2.3v31.7 c0,6.8,9.8,6.8,9.8,0V63C135.1,54.9,128.5,48.2,120.4,48.1C120.4,48.1,120.4,48.1,120.4,48.1L120.4,48.1z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: -0.3,
    fill: "none",
    width: 480.1,
    height: 182.3
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTechTableApplications3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tech_table_applications_3.ae1043100ace55cc94ce7981b3303ced.svg";